/**
 * @generated SignedSource<<2772fea399d6f23d46de21b75a630082>>
 * @relayHash f4cc23115517eeed3e15c501328b93e7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b4f35518c061684d9b02830d699da8f6e0369af043dfa9986aa7199916a4e64b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBoardQuery } from './src_jiraBoardQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b4f35518c061684d9b02830d699da8f6e0369af043dfa9986aa7199916a4e64b",
    "metadata": {},
    "name": "src_jiraBoardQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
